import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <section className="bg-white py-10" data-testid="disclaimer-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="bg-amber-50 border-l-4 border-amber-500 rounded-r-xl p-5 sm:p-6 flex gap-3 items-start">
          <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm text-amber-900 leading-relaxed">
            <strong className="text-amber-900 font-bold">Important Disclaimer:</strong> Stocks Vision Academy and Deepak Singhai do NOT guarantee profits or fixed returns. Stock market trading involves risk and past performance does not guarantee future results. All courses are strictly for educational purposes only. <strong className="font-bold">We are not SEBI Registered Investment Advisors or Research Analysts.</strong> Deepak Singhai holds the NISM Research Analyst (RA) certification for structured educational purposes only — this does not constitute SEBI registration as a Research Analyst. We do not provide investment advice, trading tips, or stock recommendations. Investments in securities markets are subject to market risks. Please read all related documents carefully before investing.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
